import React from 'react';

const ENV_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

// The key can come from the tenant settings (Admin panel) or the env var.
function resolveKey(map) {
  return (map && map.api_key) || ENV_KEY || '';
}

function hasCoords(map) {
  if (!map) return false;
  if (map.place_id) return true;
  const { lat, lng } = map;
  return lat !== undefined && lat !== null && lat !== '' && lng !== undefined && lng !== null && lng !== '';
}

// True only when both an API key and usable coordinates/place are available.
export function isMapConfigured(map) {
  return Boolean(resolveKey(map)) && hasCoords(map);
}

function buildQuery(map) {
  if (map.place_id) return `place_id:${map.place_id}`;
  return `${map.lat},${map.lng}`;
}

// Live Google Maps via the Embed API (iframe). Falls back gracefully when the
// API key or coordinates are missing so the public site never shows a broken map.
export function GoogleMapEmbed({ map, title = 'Mappa', height = 320, className = '', fallback = null }) {
  if (!isMapConfigured(map)) return fallback;

  const zoom = map.zoom || 14;
  const src = `https://www.google.com/maps/embed/v1/place?key=${resolveKey(map)}&q=${buildQuery(map)}&zoom=${zoom}`;

  return (
    <div
      data-testid="google-map-embed"
      className={`overflow-hidden rounded-card border border-paelbi-line shadow-card ${className}`}
    >
      <iframe
        title={title}
        src={src}
        width="100%"
        height={height}
        style={{ border: 0, display: 'block' }}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}

export default GoogleMapEmbed;
